import i18n from "../../../../i18n/i18n";
import {
  ChatIcon,
  DashboardIcon,
  IconAppointment,
  IconNotification,
  IconOffer,
  IconRequest,
  IconService,
  IconStaff,
  IconSubscriptionsAndAddons,
  NotifyIcon,
  ReviewsIcon,
  UserPermissionsIcon,
  TicketManagementIcon,
  WalletIcon,
} from "../../../../assets/svg";
import { baseRouteMaker, routes } from "../../../../constants/routeConsts";

export const useAdminSidebarUtils = (t) => {
  let menuGroup = [];

  /* menuItemDashboard */
  const menuItemDashboard = {
    label: t("AppModuleNames.Provider.Dashboard"),
    icon: DashboardIcon,
    path: baseRouteMaker(routes.DASHBOARD),
  };
  menuGroup.push(menuItemDashboard);
  /* menuItemDashboard */

  /* menuItemAppointment */
  const menuItemAppointment = {
    label: t("AppModuleNames.Provider.Appointments"),
    icon: IconAppointment,
    path: baseRouteMaker(routes.APPOINTMENT),
  };
  menuGroup.push(menuItemAppointment);
  /* menuItemAppointment */

  /* menuItemRequest */
  const menuItemRequest = {
    label: t("AppModuleNames.Provider.Request"),
    icon: IconRequest,
    path: baseRouteMaker(routes.REQUEST),
  };
  menuGroup.push(menuItemRequest);
  /* menuItemRequest */

  /* menuItemChat */
  const menuItemChat = {
    label: t("AppModuleNames.Provider.Chat"),
    icon: ChatIcon,
    path: baseRouteMaker(routes.CHAT),
  };
  menuGroup.push(menuItemChat);
  /* menuItemChat */

  /* menuItemSubscriptionsAndAddons */
  const menuItemSubscriptionsAndAddons = {
    label: t("AppModuleNames.Provider.Subscriptions"),
    icon: IconSubscriptionsAndAddons,
    path: baseRouteMaker(routes.SUBSCRIPTIONS_AND_ADDONS),
  };
  menuGroup.push(menuItemSubscriptionsAndAddons);
  /* menuItemSubscriptionsAndAddons */

  /* menuItemStaff */
  const menuItemStaff = {
    label: t("AppModuleNames.Provider.Staff"),
    icon: IconStaff,
    path: baseRouteMaker(routes.STAFF),
  };
  menuGroup.push(menuItemStaff);
  /* menuItemStaff */

  /* menuItemServices */
  const menuItemServices = {
    label: t("AppModuleNames.Provider.Services"),
    icon: IconService,
    path: baseRouteMaker(routes.SERVICES),

  };
  menuGroup.push(menuItemServices);
  /* menuItemServices */

  /* menuItemOfferAndPackages */
  const menuItemOfferAndPackages = {
    label: t("AppModuleNames.Provider.OffersAndPackages"),
    icon: IconOffer,
    path: baseRouteMaker(routes.OFFERS_AND_PACKAGES),
  };
  menuGroup.push(menuItemOfferAndPackages);
  /* menuItemOfferAndPackages */

  /* menuItemAddons */
  const menuItemAddons = {
    label: t("AppModuleNames.Provider.addons"),
    icon: IconSubscriptionsAndAddons,
    path: baseRouteMaker(routes.ADDONS_AND_SPONSORSHIPS),
  };
  menuGroup.push(menuItemAddons);
  /* menuItemAddons */

  /* menuItemPushNotification */
  const menuItemPushNotification = {
    label: t("AppModuleNames.Provider.PushNotification"),
    icon: NotifyIcon,
    path: baseRouteMaker(routes.PUSH_NOTIFICATION),
  };
  menuGroup.push(menuItemPushNotification);
  /* menuItemPushNotification */

  /* menuItemWallet */
  const menuItemWallet = {
    label: t("AppModuleNames.Provider.Wallet"),
    icon: WalletIcon,
    path: baseRouteMaker(routes.WALLET),
  };
  menuGroup.push(menuItemWallet);
  /* menuItemWallet */

  /* menuItemCustomerDB */
  const menuItemCustomerDB = {
    label: t("AppModuleNames.Provider.CustomerDB"),
    icon: IconOffer,
    path: baseRouteMaker(routes.SERVICE_PROVIDER_CUSTOMER_DB),
  };
  menuGroup.push(menuItemCustomerDB);
  /* menuItemCustomerDB */

  /* menuItemReviews */
  const menuItemReviews = {
    label: t("AppModuleNames.SuperAdmin.Reviews"),
    icon: ReviewsIcon,
    path: baseRouteMaker(routes.SERVICE_PROVIDER_REVIEWS),
  };
  menuGroup.push(menuItemReviews);

  /* menuItemUserPermissions */
  const menuItemUserPermissions = {
    label: t("AppModuleNames.SuperAdmin.UserPermissions"),
    icon: UserPermissionsIcon,
    path: baseRouteMaker(routes.USER_PERMISSIONS),
  };
  menuGroup.push(menuItemUserPermissions);

  /* menuItemHelpAndSupport */
  const menuItemHelpAndSupport = {
    label: t("AppModuleNames.SuperAdmin.HelpAndSupport"),
    icon: TicketManagementIcon,
    path: baseRouteMaker(routes.HELP_AND_SUPPORT),
  };
  menuGroup.push(menuItemHelpAndSupport);
  /* menuItemHelpAndSupport */

  return menuGroup;
};
